// extracted by mini-css-extract-plugin
export default {"messageBtn":"styles_messageBtn__iVvwH","messageIcon":"styles_messageIcon__zuGvD"};